import { Button, Modal } from 'antd';
import axios from 'axios';
import useSWR from 'swr';
import styles from './FilePreviewModal.module.css';

export default function FilePreviewModal({ open, setOpen, file }) {
   // get file from api
   const fileData = useSWR(open ? `api/library/file/${file._id}` : null);

   async function handleDownload() {
      // download file from url
      const downloadFile = await axios({
         url: fileData?.data?.url,
         method: 'GET',
         responseType: 'blob', // important
      });
      const url = window.URL.createObjectURL(new Blob([downloadFile.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file?.name || 'file');
      document.body.appendChild(link);
      link.click();
      // remove element after download
      link.parentNode.removeChild(link);
   }

   return (
      <Modal
         destroyOnClose={true}
         open={open}
         closable={false}
         maskClosable={false}
         footer={null}
         width={'100%'}
         style={{ top: 0, height: '100vh' }}
         styles={{ body: { height: '100%', padding: 0 } }}
         onCancel={() => setOpen(false)}
         maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.88)' }}
         modalRender={(modal) => <div className={styles.modal}>{modal}</div>}
      >
         <div className={styles.container}>
            <div className={styles.header}>
               <div className={styles.title}>{file.name}</div>
               <div className={styles.actions}>
                  <Button type="default" onClick={handleDownload} loading={fileData?.isLoading}>
                     Download <i className="fas fa-download"></i>
                  </Button>
                  <Button type="text" icon={<i class="fi fi-rr-circle-xmark"></i>} onClick={() => setOpen(false)} />
               </div>
            </div>
            <div className={styles.content}>
               <img src={file?.file?.preview} alt={file.name} className={styles.preview} />
            </div>
         </div>
      </Modal>
   );
}
